// extracted by mini-css-extract-plugin
module.exports = {"modal":"ContactoModal_modal___6dQl","texto":"ContactoModal_texto__2C7G7","btn":"ContactoModal_btn__20Q-q"};